import { isDeepEqual } from '@attain-apps/data-utils'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'
import * as models from '../models'

export const saveOnDataChange = store.effects.create((feature: Feature) =>
  rxjs.from(models.OrgChart.Id.ALL).pipe(
    rxjs.mergeMap(orgChartId =>
      feature.selectors.getOrgChartData({ orgChartId }).asObservable.pipe(
        // Just extra assurance that we really only do this when the data
        // actually changes
        rxjs.distinctUntilChanged(isDeepEqual),
        rxjs.map(() =>
          feature.actions.save.from('saveOnDataChange').create({ orgChartId }),
        ),
      ),
    ),
  ),
)
